export default __webpack_public_path__ + "static/iPhoneFrameCutOffWhite-3023a2ed925019a983a835261f251d0f.png";